var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 70,
    viewBox: "0 0 198 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1760_89306)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 182,
    height: 54,
    rx: 5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8568 33.364C92.686 33.364 90.1016 35.7792 90.1016 39.1056C90.1016 42.4117 92.686 44.8471 95.8568 44.8471C99.029 44.8471 101.613 42.4117 101.613 39.1056C101.612 35.7792 99.0277 33.364 95.8568 33.364ZM95.8568 42.5872C94.119 42.5872 92.6213 41.1522 92.6213 39.1069C92.6213 37.0401 94.1204 35.6266 95.8568 35.6266C97.5946 35.6266 99.0924 37.0401 99.0924 39.1069C99.0924 41.1508 97.5946 42.5872 95.8568 42.5872ZM83.3002 33.364C80.1293 33.364 77.5449 35.7792 77.5449 39.1056C77.5449 42.4117 80.1293 44.8471 83.3002 44.8471C86.4723 44.8471 89.0568 42.4117 89.0568 39.1056C89.0568 35.7792 86.4723 33.364 83.3002 33.364ZM83.3002 42.5872C81.5624 42.5872 80.0646 41.1522 80.0646 39.1069C80.0646 37.0401 81.5637 35.6266 83.3002 35.6266C85.0379 35.6266 86.5357 37.0401 86.5357 39.1069C86.5371 41.1508 85.0379 42.5872 83.3002 42.5872ZM68.3654 35.1271V37.5625H74.1867C74.0128 38.9328 73.5571 39.9331 72.8614 40.6284C72.0148 41.4762 70.6896 42.4117 68.3654 42.4117C64.782 42.4117 61.9805 39.5187 61.9805 35.9304C61.9805 32.3421 64.782 29.449 68.3654 29.449C70.2986 29.449 71.7101 30.2104 72.7522 31.1892L74.4684 29.4706C73.0124 28.0788 71.0805 27.0136 68.3654 27.0136C63.4568 27.0136 59.3301 31.015 59.3301 35.9304C59.3301 40.8457 63.4568 44.8471 68.3654 44.8471C71.0145 44.8471 73.0138 43.9764 74.5763 42.3456C76.1833 40.7364 76.6834 38.4738 76.6834 36.6472C76.6834 36.0829 76.6403 35.5605 76.5527 35.1258H68.3654V35.1271ZM129.447 37.0185C128.97 35.736 127.514 33.364 124.539 33.364C121.585 33.364 119.13 35.6914 119.13 39.1056C119.13 42.324 121.563 44.8471 124.82 44.8471C127.448 44.8471 128.969 43.2379 129.6 42.3024L127.645 40.9969C126.994 41.9541 126.103 42.5845 124.82 42.5845C123.54 42.5845 122.627 41.9973 122.041 40.8444L129.707 37.6692L129.447 37.0185ZM121.628 38.9328C121.563 36.7134 123.344 35.5834 124.626 35.5834C125.625 35.5834 126.472 36.0843 126.755 36.8011L121.628 38.9328ZM115.396 44.5002H117.914V27.6238H115.396V44.5002ZM111.267 34.6479H111.181C110.616 33.9729 109.53 33.364 108.163 33.364C105.295 33.364 102.668 35.8872 102.668 39.1285C102.668 42.3469 105.295 44.8485 108.163 44.8485C109.531 44.8485 110.616 44.2396 111.181 43.5444H111.267V44.3706C111.267 46.567 110.095 47.7415 108.206 47.7415C106.664 47.7415 105.708 46.6332 105.317 45.6976L103.123 46.6116C103.753 48.133 105.425 50.0041 108.206 50.0041C111.16 50.0041 113.658 48.264 113.658 44.0223V33.7137H111.269V34.6479H111.267ZM108.38 42.5872C106.642 42.5872 105.187 41.1292 105.187 39.1285C105.187 37.1049 106.642 35.6266 108.38 35.6266C110.095 35.6266 111.441 37.1049 111.441 39.1285C111.441 41.1292 110.095 42.5872 108.38 42.5872ZM141.249 27.6238H135.221V44.5002H137.736V38.1066H141.248C144.036 38.1066 146.778 36.0856 146.778 32.8659C146.778 29.6461 144.037 27.6238 141.249 27.6238ZM141.314 35.7576H137.736V29.9728H141.314C143.194 29.9728 144.262 31.5321 144.262 32.8659C144.262 34.1727 143.194 35.7576 141.314 35.7576ZM156.861 33.3343C155.039 33.3343 153.153 34.1376 152.373 35.9182L154.605 36.8511C155.082 35.9182 155.972 35.6131 156.904 35.6131C158.205 35.6131 159.527 36.3948 159.549 37.7839V37.9581C159.093 37.6975 158.117 37.3074 156.925 37.3074C154.519 37.3074 152.068 38.6317 152.068 41.1063C152.068 43.3648 154.042 44.8188 156.252 44.8188C157.943 44.8188 158.876 44.0587 159.461 43.1677H159.547V44.4705H161.977V37.9999C161.978 35.0056 159.743 33.3343 156.861 33.3343ZM156.556 42.5832C155.733 42.5832 154.583 42.1701 154.583 41.1495C154.583 39.8467 156.015 39.3472 157.251 39.3472C158.356 39.3472 158.877 39.5862 159.549 39.9115C159.353 41.4762 158.009 42.5832 156.556 42.5832ZM170.823 33.7029L167.94 41.0199H167.853L164.86 33.7029H162.151L166.639 43.9291L164.08 49.618H166.703L173.621 33.7029H170.823ZM148.166 44.5002H150.681V27.6238H148.166V44.5002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9259 17.828C67.9259 18.9593 67.5916 19.8597 66.9215 20.532C66.1612 21.3312 65.169 21.7308 63.9502 21.7308C62.7827 21.7308 61.7891 21.3258 60.9735 20.5158C60.1565 19.7045 59.748 18.7001 59.748 17.5013C59.748 16.3011 60.1565 15.2967 60.9735 14.4867C61.7891 13.6754 62.7827 13.2704 63.9502 13.2704C64.5299 13.2704 65.084 13.3838 65.6098 13.6092C66.1369 13.836 66.5589 14.1371 66.8744 14.5137L66.1639 15.2265C65.6287 14.5853 64.8912 14.2653 63.9489 14.2653C63.0968 14.2653 62.3608 14.565 61.7393 15.1644C61.1178 15.7638 60.8077 16.5428 60.8077 17.4999C60.8077 18.4571 61.1178 19.236 61.7393 19.8354C62.3608 20.4348 63.0968 20.7345 63.9489 20.7345C64.8521 20.7345 65.6058 20.4335 66.2084 19.83C66.5993 19.4372 66.8258 18.8904 66.8865 18.1898H63.9489V17.2164H67.8679C67.9084 17.4284 67.9259 17.6322 67.9259 17.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.141 14.4449H70.4579V17.0126H73.7797V17.986H70.4579V20.5537H74.141V21.55H69.4184V13.45H74.141V14.4449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5237 21.55H77.4843V14.4449H75.2248V13.45H80.7832V14.4449H78.5237V21.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8046 21.55V13.45H85.8441V21.55H84.8046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4536 21.55H89.4142V14.4449H87.1547V13.45H92.7131V14.4449H90.4536V21.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.235 20.5037C102.44 21.3218 101.451 21.7309 100.269 21.7309C99.0868 21.7309 98.0987 21.3218 97.3046 20.5037C96.5092 19.6856 96.1128 18.6839 96.1128 17.5C96.1128 16.316 96.5092 15.3143 97.3046 14.4962C98.0987 13.6781 99.0868 13.2677 100.269 13.2677C101.445 13.2677 102.432 13.6795 103.23 14.5016C104.028 15.3238 104.427 16.3228 104.427 17.5C104.427 18.6839 104.029 19.6856 103.235 20.5037ZM98.0717 19.8247C98.6703 20.4322 99.4023 20.7346 100.269 20.7346C101.136 20.7346 101.869 20.4308 102.467 19.8247C103.065 19.2172 103.366 18.4423 103.366 17.5C103.366 16.5577 103.065 15.7828 102.467 15.1753C101.869 14.5678 101.136 14.2654 100.269 14.2654C99.4023 14.2654 98.6703 14.5691 98.0717 15.1753C97.4745 15.7828 97.1738 16.5577 97.1738 17.5C97.1738 18.4423 97.4745 19.2172 98.0717 19.8247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.886 21.55V13.45H107.15L111.081 19.7504H111.126L111.081 18.1898V13.45H112.121V21.55H111.036L106.922 14.9431H106.878L106.922 16.5037V21.55H105.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9259 17.828C67.9259 18.9593 67.5916 19.8597 66.9215 20.532C66.1612 21.3312 65.169 21.7308 63.9502 21.7308C62.7827 21.7308 61.7891 21.3258 60.9735 20.5158C60.1565 19.7045 59.748 18.7001 59.748 17.5013C59.748 16.3011 60.1565 15.2967 60.9735 14.4867C61.7891 13.6754 62.7827 13.2704 63.9502 13.2704C64.5299 13.2704 65.084 13.3838 65.6098 13.6092C66.1369 13.836 66.5589 14.1371 66.8744 14.5137L66.1639 15.2265C65.6287 14.5853 64.8912 14.2653 63.9489 14.2653C63.0968 14.2653 62.3608 14.565 61.7393 15.1644C61.1178 15.7638 60.8077 16.5428 60.8077 17.4999C60.8077 18.4571 61.1178 19.236 61.7393 19.8354C62.3608 20.4348 63.0968 20.7345 63.9489 20.7345C64.8521 20.7345 65.6058 20.4335 66.2084 19.83C66.5993 19.4372 66.8258 18.8904 66.8865 18.1898H63.9489V17.2164H67.8679C67.9084 17.4284 67.9259 17.6322 67.9259 17.828Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.141 14.4449H70.4579V17.0126H73.7797V17.986H70.4579V20.5537H74.141V21.55H69.4184V13.45H74.141V14.4449Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5237 21.55H77.4843V14.4449H75.2248V13.45H80.7832V14.4449H78.5237V21.55Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8046 21.55V13.45H85.8441V21.55H84.8046Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4536 21.55H89.4142V14.4449H87.1547V13.45H92.7131V14.4449H90.4536V21.55Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.235 20.5037C102.44 21.3218 101.451 21.7309 100.269 21.7309C99.0868 21.7309 98.0987 21.3218 97.3046 20.5037C96.5092 19.6856 96.1128 18.6839 96.1128 17.5C96.1128 16.316 96.5092 15.3143 97.3046 14.4962C98.0987 13.6781 99.0868 13.2677 100.269 13.2677C101.445 13.2677 102.432 13.6795 103.23 14.5016C104.028 15.3238 104.427 16.3228 104.427 17.5C104.427 18.6839 104.029 19.6856 103.235 20.5037ZM98.0717 19.8247C98.6703 20.4322 99.4023 20.7346 100.269 20.7346C101.136 20.7346 101.869 20.4308 102.467 19.8247C103.065 19.2172 103.366 18.4423 103.366 17.5C103.366 16.5577 103.065 15.7828 102.467 15.1753C101.869 14.5678 101.136 14.2654 100.269 14.2654C99.4023 14.2654 98.6703 14.5691 98.0717 15.1753C97.4745 15.7828 97.1738 16.5577 97.1738 17.5C97.1738 18.4423 97.4745 19.2172 98.0717 19.8247Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.886 21.55V13.45H107.15L111.081 19.7504H111.126L111.081 18.1898V13.45H112.121V21.55H111.036L106.922 14.9431H106.878L106.922 16.5037V21.55H105.886Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_1760_89306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0695 14.1763C17.6772 14.5921 17.4453 15.2374 17.4453 16.073V45.9296C17.4453 46.7666 17.6772 47.4106 18.0695 47.8264L18.1693 47.9236L34.8715 31.1984V31.0013V30.8042L18.1693 14.0777L18.0695 14.1763Z",
    fill: "url(#paint0_linear_1760_89306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4376 36.7753L34.8711 31.1984V31.0013V30.8042L40.4389 25.2287L40.5643 25.3002L47.1608 29.0533C49.0442 30.1252 49.0442 31.8788 47.1608 32.952L40.5643 36.7051L40.4376 36.7753Z",
    fill: "url(#paint1_linear_1760_89306)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1760_89306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5655 36.7038L34.8709 31.0014L18.0703 47.8265C18.6905 48.4853 19.7164 48.5663 20.8718 47.9102L40.5655 36.7038Z",
    fill: "url(#paint2_linear_1760_89306)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.5655 25.299L20.8718 14.094C19.7164 13.4365 18.6905 13.5189 18.0703 14.1777L34.8723 31.0027L40.5655 25.299Z",
    fill: "url(#paint3_linear_1760_89306)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1760_89306",
    x: 0,
    y: 0,
    width: 198,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1760_89306"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1760_89306",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_1760_89306",
    x: 17.4453,
    y: 13.6403,
    width: 31.1289,
    height: 34.7231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1760_89306"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1760_89306",
    result: "effect2_innerShadow_1760_89306"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1760_89306",
    x: 18.0703,
    y: 31.0014,
    width: 22.4961,
    height: 17.3619,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1760_89306"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1760_89306",
    x1: 33.3909,
    y1: 15.7571,
    x2: 10.7353,
    y2: 38.3817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1760_89306",
    x1: 49.6124,
    y1: 31.0013,
    x2: 16.9928,
    y2: 31.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1760_89306",
    x1: 37.473,
    y1: 34.0982,
    x2: 6.74906,
    y2: 64.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1760_89306",
    x1: 13.839,
    y1: 4.23869,
    x2: 27.5581,
    y2: 17.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.3b3bb31a9d93e51308b67056399c23f9.svg";
export { ForwardRef as ReactComponent };